'use strict';

var MarketProductGroupMarketFilterFactory = function MarketProductGroupMarketFilterFactory(DataFilter) {
  function MarketProductGroupMarketFilter() {
    this.sourceType = ['market-product-group', 'market'];
    this.filterType = 'markets';
  }
  MarketProductGroupMarketFilter.constructor = MarketProductGroupMarketFilter;
  MarketProductGroupMarketFilter.prototype = Object.create(DataFilter.prototype);
  MarketProductGroupMarketFilter.prototype.groupBy = 'market';
  return MarketProductGroupMarketFilter;
};
MarketProductGroupMarketFilterFactory.$inject = ['DataFilterFactory'];
module.exports = MarketProductGroupMarketFilterFactory;